import type { FC } from 'react';
import { ReactComponent as MusicEffectsIcon } from 'assets/musicEffects.svg';

import { Box, Typography } from '@mui/material';
import { colorsSelector } from '@redux/colorPalette/selectors';
import { selectedVocalEffectSelector } from '@redux/featureFlags/selector';

import analytics from 'lib/analytics';
import { useSelector } from 'react-redux';

import AudioOptionButton from 'components/b2b/ControlBar/ControlBarContent/VoiceControl/AudioOptionButton';
import { AudioOptionButtonState } from 'components/b2b/ControlBar/ControlBarContent/VoiceControl/AudioOptionButton/AudioOptionButton.const';

import { VocalEffects } from 'constants/vocalPresets';
import { useLocation, useNavigate } from 'react-router';
import { PATHS } from 'constants/pathsB2b';

const VoiceModification: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const colors = useSelector(colorsSelector);
  const selectedEffect = useSelector(selectedVocalEffectSelector);

  const handleClick = () => {
    if (pathname !== PATHS.EFFECTS) {
      analytics.track('Effects_Opened');
    }
    navigate(PATHS.EFFECTS);
  };

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <Typography
        sx={{
          position: 'absolute',
          zIndex: 1,
          backgroundColor: colors.highlightPoint,
          fontFamily: "'Roboto'",
          fontWeight: 'bold',
          fontSize: '8px',
          padding: '3px',
          borderRadius: '5px',
          right: 5,
          transform: 'rotate(-10deg)',
        }}
      >
        NEW !
      </Typography>
      <AudioOptionButton
        Icon={MusicEffectsIcon}
        translationId='control-bar.effects'
        buttonState={
          selectedEffect === VocalEffects.DEFAULT
            ? AudioOptionButtonState.INACTIVE
            : AudioOptionButtonState.ACTIVE
        }
        onClick={handleClick}
      />
    </Box>
  );
};

export default VoiceModification;
